<template>
    <v-row>
        <v-col cols="12">
            <v-alert
                color="#856404"
                dark
                icon="mdi-alert"
                border="right"
                text
                >
                <strong>IMPORTANTE</strong>: Este producto es para quién sólo quiera cambiar de Banco, sin ampliar capital para ningún destino. En caso de que quieras cambiar de Banco y que necesites más dinero para liquidez o cancelar algún préstamo adicional, tienes que pinchar <span style="cursor: pointer; color:#25CCD5" @click="callChangeActiveProduct('ampliacion')">aquí</span> 
            </v-alert>
        </v-col>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="Valor de mercado de tu vivienda *"
                v-model="preScoring.Vivienda.valor"
                :rules="[...ruleMin10000,...ruleMax100M]"
                outlined
                append-icon="mdi-currency-eur"
                hint="Si no conoces la cantidad definitiva introduce una estimación"
                persistent-hint
                dense
            ></v-currency-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="Capital pendiente de hipoteca *"
                outlined
                placeholder="200.000€"
                v-model="preScoring.Vivienda.capital_pendiente"
                :rules="[...ruleRequired,...ruleMax100M]"
                :min="0"
                append-icon="mdi-currency-eur"
                hint="(Dinero que le debes al banco)"
                persistent-hint
                dense
            ></v-currency-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="¿Cuánto te queda por pagar de otros prestamos? *"
                outlined
                placeholder="40.000€"
                v-model="preScoring.Vivienda.total_deudas"
                :rules="[...ruleRequired,...ruleMax100M]"
                :min="0"
                append-icon="mdi-currency-eur"
                hint="Recuerda que aquí nos tienes que indicar si tienes préstamos que NO incluirás en ésta financiación"
                persistent-hint
                dense
            ></v-currency-field>
        </v-col>



        <v-col cols=12 sm=6>
            <v-text-field
                label="Dirección de la vivienda (si la tiene)"
                outlined
                v-model="preScoring.Vivienda.direccion"
                dense
            ></v-text-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-autocomplete 
                label="Comunidad autónoma *"
                outlined
                v-model="preScoring.Vivienda.ccaa"
                :items="commonVars.ccaa"
                :rules="[...ruleRequired]"
                item-text="name"
                item-value="code"
                dense
            />
        </v-col>
        <v-col cols=12 sm=6>
            <v-text-field
                label="Código postal"
                outlined
                v-model="preScoring.Vivienda.cp"
                dense
            ></v-text-field>
        </v-col>
        <v-col cols=12 sm=12>
            <v-textarea
                label="Comentario"
                placeholder='Explícanos los detalles relevantes de tu operación. Cuantos más detalles nos cuentes, más conocimiento de lo que estás buscando y mejores soluciones te propondremos'
                v-model="preScoring.Vivienda.comentario"
                outlined
                dense
            ></v-textarea>
        </v-col>
    </v-row>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';

    export default {
        mixins: [rulesMixin],
        methods: {
            ...mapMutations([
                'SET_ACTIVE_STEP',
                'CHANGE_ACTIVE_PRODUCT',
                'SET_DATE_KEYS',
                'SET_VALUE'
            ]), 
            callChangeActiveProduct(type='ampliacion'){
                this.CHANGE_ACTIVE_PRODUCT(type);
                this.change = false;
            },
        },
        data() {
            return {
                change: false
            }
        },
        computed: {
            ...mapState([
                'preScoring',
                'commonVars',
                'token_id',
                'propertyStatuses',
                'propertyNew'
            ]),
        }

    }
</script>
